export default __webpack_public_path__ + "static/eksempeldesign-cb77cecf0516d60685f703e240f7697d.png";